module.exports = __webpack_public_path__ + "static/article-1-a4cea8a1ad30d9657b113bc90de13790.jpg";